import Modal, { ModalProps } from './Modal';
import ModalBody, { ModalBodyProps } from './ModalBody';
import ModalHeader, { ModalHeaderProps } from './ModalHeader';

export default Modal;
export { ModalBody, ModalBodyProps, ModalHeader, ModalHeaderProps, ModalProps };
